/** Dummy + chart datasets for MediTrack dashboard (swap with API data in production). */

export const DUMMY_REPORTS = [
  {
    id: "CBC2412",
    date: "Dec 15, 2024",
    testName: "Complete Blood Count",
    category: "Hematology",
    keyResult: "WBC 7.2 | RBC 5.1",
    status: "Normal",
    doctor: "Dr. Sarah Chen"
  },
  {
    id: "LIP2411",
    date: "Nov 28, 2024",
    testName: "Lipid Profile",
    category: "Cardiology",
    keyResult: "LDL 142 mg/dL",
    status: "Attention",
    doctor: "Dr. Mike Ross"
  },
  {
    id: "THY2411",
    date: "Nov 10, 2024",
    testName: "Thyroid (TSH)",
    category: "Endocrinology",
    keyResult: "TSH 2.1 mIU/L",
    status: "Normal",
    doctor: "Dr. Priya Nair"
  },
  {
    id: "HBA2410",
    date: "Oct 22, 2024",
    testName: "HbA1c Glucose",
    category: "Diabetes",
    keyResult: "HbA1c 6.8%",
    status: "Attention",
    doctor: "Dr. Sarah Chen"
  },
  {
    id: "LFT2410",
    date: "Oct 05, 2024",
    testName: "Liver Function",
    category: "Gastroenterology",
    keyResult: "ALT 32 U/L",
    status: "Normal",
    doctor: "Dr. Alan Park"
  },
  {
    id: "KFT2409",
    date: "Sep 18, 2024",
    testName: "Kidney Function",
    category: "Nephrology",
    keyResult: "Creatinine 1.1",
    status: "Normal",
    doctor: "Dr. Alan Park"
  },
  {
    id: "VIT2409",
    date: "Sep 02, 2024",
    testName: "Vitamin D & B12",
    category: "Nutrition",
    keyResult: "Vit D 18 ng/mL",
    status: "Critical",
    doctor: "Dr. Priya Nair"
  },
  {
    id: "URN2408",
    date: "Aug 14, 2024",
    testName: "Urine Analysis",
    category: "Urology",
    keyResult: "No abnormality",
    status: "Normal",
    doctor: "Dr. Mike Ross"
  }
];

export const SUMMARY_STATS = [
  { key: "total", label: "Total Reports", value: "24", note: "All time records", icon: "clipboard" },
  { key: "normal", label: "Normal", value: "17", note: "Within reference range", icon: "check" },
  { key: "attention", label: "Needs attention", value: "5", note: "Slight deviations", icon: "alert" },
  { key: "critical", label: "Critical", value: "2", note: "Review soon", icon: "alertOctagon" },
  { key: "last", label: "Last report", value: "Dec 2024", note: "Blood panel complete", icon: "calendar" }
];

export const BLOOD_COUNT_TREND = [
  { month: "Jul", wbc: 6.8, rbc: 4.8, hgb: 13.5 },
  { month: "Aug", wbc: 7.0, rbc: 4.9, hgb: 13.8 },
  { month: "Sep", wbc: 7.1, rbc: 5.0, hgb: 14.0 },
  { month: "Oct", wbc: 6.9, rbc: 5.1, hgb: 13.9 },
  { month: "Nov", wbc: 7.3, rbc: 5.0, hgb: 14.2 },
  { month: "Dec", wbc: 7.2, rbc: 5.1, hgb: 14.1 }
];

export const LIPID_COMPARISON = [
  { period: "Jul 2024", ldl: 158, hdl: 48, trig: 180 },
  { period: "Sep 2024", ldl: 149, hdl: 52, trig: 165 },
  { period: "Nov 2024", ldl: 142, hdl: 55, trig: 150 }
];

export const RADAR_HEALTH = [
  { domain: "Blood", current: 88, previous: 80 },
  { domain: "Heart", current: 72, previous: 65 },
  { domain: "Kidney", current: 91, previous: 88 },
  { domain: "Liver", current: 95, previous: 90 },
  { domain: "Thyroid", current: 89, previous: 84 },
  { domain: "Nutrition", current: 60, previous: 55 }
];

export const GLUCOSE_TREND = [
  { month: "Jan", glucose: 98, hba1c: 5.8 },
  { month: "Feb", glucose: 102, hba1c: 5.9 },
  { month: "Mar", glucose: 105, hba1c: 6.1 },
  { month: "Apr", glucose: 110, hba1c: 6.3 },
  { month: "May", glucose: 108, hba1c: 6.2 },
  { month: "Jun", glucose: 112, hba1c: 6.4 },
  { month: "Jul", glucose: 109, hba1c: 6.5 },
  { month: "Aug", glucose: 107, hba1c: 6.4 },
  { month: "Sep", glucose: 111, hba1c: 6.6 },
  { month: "Oct", glucose: 115, hba1c: 6.8 },
  { month: "Nov", glucose: 113, hba1c: 6.7 },
  { month: "Dec", glucose: 110, hba1c: 6.8 }
];

export const TSH_TREND = [
  { month: "Jan", tsh: 1.8 },
  { month: "Mar", tsh: 2.0 },
  { month: "May", tsh: 2.3 },
  { month: "Jul", tsh: 2.1 },
  { month: "Sep", tsh: 2.4 },
  { month: "Nov", tsh: 2.2 },
  { month: "Dec", tsh: 2.1 }
];

export const VITAMIN_LEVELS = [
  { month: "Mar", vitD: 12, b12: 280 },
  { month: "Jun", vitD: 15, b12: 310 },
  { month: "Sep", vitD: 18, b12: 340 },
  { month: "Dec", vitD: 18, b12: 370 }
];

export const BMI_TREND = [
  { month: "Jan", bmi: 27.2 },
  { month: "Feb", bmi: 27.0 },
  { month: "Mar", bmi: 26.8 },
  { month: "Apr", bmi: 26.5 },
  { month: "May", bmi: 26.3 },
  { month: "Jun", bmi: 26.1 },
  { month: "Jul", bmi: 25.9 },
  { month: "Aug", bmi: 25.7 },
  { month: "Sep", bmi: 25.5 },
  { month: "Oct", bmi: 25.4 },
  { month: "Nov", bmi: 25.3 },
  { month: "Dec", bmi: 25.1 }
];

export const STATUS_DISTRIBUTION = [
  { name: "Normal", value: 17 },
  { name: "Attention", value: 5 },
  { name: "Critical", value: 2 },
  { name: "Pending", value: 0 }
];

export const CATEGORY_COUNTS = [
  { category: "Hematology", count: 5 },
  { category: "Cardiology", count: 4 },
  { category: "Endocrinology", count: 4 },
  { category: "Nutrition", count: 3 },
  { category: "Nephrology", count: 3 },
  { category: "Gastro", count: 2 },
  { category: "Other", count: 3 }
];

export const AI_INSIGHTS = [
  {
    title: "Pre-diabetes risk",
    status: "warning",
    description:
      "HbA1c at 6.8% is in the pre-diabetes range. Fasting glucose rose ~12% over 12 months — prioritize follow-up and lifestyle review.",
    data_points: ["HbA1c: 6.8%", "Trend: 6.1% → 6.8%", "Change: +12%"],
    action: "Schedule HbA1c retest and consider lifestyle counseling."
  },
  {
    title: "Vitamin D deficiency",
    status: "critical",
    description:
      "Vitamin D at 18 ng/mL is below typical sufficiency targets. Discuss supplementation and re-testing with your clinician.",
    data_points: ["Vitamin D: 18 ng/mL", "Normal range: 30–100 ng/mL"],
    action: "Discuss D3 supplementation and recheck in 8–12 weeks."
  },
  {
    title: "Liver & kidney stable",
    status: "positive",
    description: "ALT, AST, and creatinine remain in range with an improving trend over the last two quarters.",
    data_points: ["ALT: 32 U/L", "Creatinine: 1.1 mg/dL"],
    action: null
  },
  {
    title: "Lipids improving",
    status: "positive",
    description: "LDL fell from 158 → 142 mg/dL while HDL rose from 48 → 55 mg/dL. Continue current nutrition and activity plan.",
    data_points: ["LDL: 158 → 142 mg/dL", "HDL: 48 → 55 mg/dL"],
    action: null
  }
];

export const AI_SUGGESTIONS = {
  alerts: [
    {
      type: "critical",
      title: "Immediate Action Required",
      description: "Your HbA1c is 6.8%, which is 21% above the normal limit (5.6%). This suggests a critical level of concern regarding diabetes risk.",
      metrics: {
        current: "6.8%",
        normal_range: "<5.6%",
        deviation: "1.2%",
        percentage: "21%"
      },
      doctor: "Endocrinologist",
      timeline: "Within 7 days"
    },
    {
      type: "warning",
      title: "Monitor Closely",
      description: "LDL cholesterol at 142 mg/dL remains 42% above the recommended threshold (100 mg/dL).",
      metrics: {
        current: "142 mg/dL",
        normal_range: "<100 mg/dL",
        deviation: "42 mg/dL",
        percentage: "42%"
      },
      doctor: "Cardiologist",
      timeline: "Within 2-4 weeks"
    }
  ],
  action_plan_30_days: [
    {
      day_range: "Day 1-7",
      title: "Primary medical action",
      steps: [
        "Book consultation with Endocrinologist",
        "Gather previous 3 lab reports for comparison",
        "Review current medications and supplements"
      ]
    },
    {
      day_range: "Day 8-15",
      title: "Diet & lifestyle correction",
      steps: [
        "Prioritize low-glycemic foods, eliminate refined sugars.",
        "Start a food and symptoms journal",
        "Identify and remove 'trigger' foods"
      ]
    },
    {
      day_range: "Day 16-23",
      title: "Physical activity & recovery",
      steps: [
        "Aim for at least 150 minutes of moderate activity per week.",
        "Begin with 20-minute daily walks",
        "Monitor energy levels and recovery"
      ]
    },
    {
      day_range: "Day 24-30",
      title: "Monitoring & follow-up",
      steps: [
        "Plan re-test for HbA1c and Lipids",
        "Check progress against initial goals",
        "Schedule secondary follow-up if needed"
      ]
    }
  ],
  urgent_actions: [
    {
      title: "HbA1c Management",
      description: "Follow up with an Endocrinologist regarding your value of 6.8%."
    },
    {
      title: "Lipid Profile Management",
      description: "Discuss LDL levels of 142 mg/dL with a Cardiologist."
    }
  ],
  lifestyle_focus: [
    {
      title: "Diet focus",
      description: "Prioritize low-glycemic foods, eliminate refined sugars, and increase fiber intake."
    },
    {
      title: "Physical activity",
      description: "Incorporate 15–20 minutes of safe sun exposure alongside your daily brisk walk."
    },
    {
      title: "Sleep & recovery",
      description: "Target 7–9 hours of quality sleep to support metabolic recovery and insulin sensitivity."
    }
  ]
};

// Kept for backward compat or components not yet updated
export const AI_SUGGESTION_STEPS = AI_SUGGESTIONS.urgent_actions.map(a => ({ title: a.title, detail: a.description }));
export const LIFESTYLE_STEPS = AI_SUGGESTIONS.lifestyle_focus.map(f => ({ title: f.title, detail: f.description }));
export const PERSONALIZED_ALERTS = AI_SUGGESTIONS.alerts;
export const THIRTY_DAY_ACTION_PLAN = AI_SUGGESTIONS.action_plan_30_days;


export const SCHEDULE_ROWS = [
  { test: "HbA1c + Fasting Glucose", by: "Jan 2025 (1 mo)", priority: "Urgent", formId: "HBA-FORM" },
  { test: "Vitamin D & B12", by: "Feb 2025 (2 mo)", priority: "Urgent", formId: "VIT-FORM" },
  { test: "Lipid Profile", by: "Mar 2025 (3 mo)", priority: "High", formId: "LIP-FORM" },
  { test: "TSH Thyroid", by: "Mar 2025 (3 mo)", priority: "Medium", formId: "TSH-FORM" },
  { test: "Complete Blood Count", by: "Apr 2025 (4 mo)", priority: "Medium", formId: "CBC-FORM" },
  { test: "Kidney & Liver Panel", by: "Jun 2025 (6 mo)", priority: "Routine", formId: "KLF-FORM" },
  { test: "Urine Routine", by: "Jun 2025 (6 mo)", priority: "Routine", formId: "URN-FORM" },
  { test: "Full Body Check", by: "Dec 2025 (annual)", priority: "Routine", formId: "FBC-FORM" }
];

export const CHART_COLORS = {
  primary: "#2563eb",
  primaryMuted: "#93c5fd",
  secondary: "#64748b",
  success: "#10b981",
  warning: "#f59e0b",
  danger: "#ef4444",
  indigo: "#6366f1",
  violet: "#8b5cf6"
};
